import styled, { keyframes } from 'styled-components';
import { getProp } from 'utils/styled';
import { ProgressBarStyleProps } from './types';

const indetermianteAnim = keyframes`
  0% {
    transform: translateX(-200%);
  }
  100% {
    transform: translateX(167%);
  }
`;

export const ProgressBarTrack = styled.div<ProgressBarStyleProps>`
  align-items: center;
  background-color: ${getProp('$color')};
  border-radius: 1000px;
  display: flex;
  height: 16px;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

export const ProgressBarFill = styled.div<ProgressBarStyleProps>`
  background-color: ${getProp('$color')};
  border-radius: inherit;
  height: 100%;
  position: absolute;
  transition: transform 250ms linear;
  right: 100%;
  width: 100%;
`;

export const ProgressBarFillIndeterminate = styled(
  ProgressBarFill,
)<ProgressBarStyleProps>`
  left: 0;
  right: auto;
  width: 60%;
  animation: ${indetermianteAnim} 2s ease-in-out infinite;
`;
